import { action, createRequestTypes } from '@/utils/actions.utils'
import { productsService } from '@/services'

export const FETCH_PRODUCTS_BY_REF = createRequestTypes('FETCH_PRODUCTS_BY_REF')
const fetchProductsByRef = ({ catalogId, matchingTerm, lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ matchingTerm }))

			const res = await productsService.fetchProductsByRef({
				catalogId,
				matchingTerm,
				lang
			})

			return dispatch(
				success({
					matchingTerm,
					coincidences: res.data
				})
			)
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request(payload) {
		return action(FETCH_PRODUCTS_BY_REF.REQUEST, payload)
	}
	function success(payload) {
		return action(FETCH_PRODUCTS_BY_REF.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_PRODUCTS_BY_REF.FAILURE, null, err)
	}
}

export const FETCH_MODELS = createRequestTypes('FETCH_MODELS')
const fetchModels = ({ catalogId, subFamilyId, applicationLocationId }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await productsService.fetchModels({
				catalogId,
				subFamilyId,
				applicationLocationId
			})

			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(FETCH_REFERENCES.REQUEST)
	}
	function success(payload) {
		return action(FETCH_REFERENCES.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_REFERENCES.FAILURE, null, err)
	}
}

// DEPRECATED: Don't use. Categories are not created for all products right now.
export const FETCH_REFERENCES = createRequestTypes('FETCH_REFERENCES')
const fetchReferences = ({ catalogId, subFamilyId, applicationLocationId, lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await productsService.fetchReferences({
				catalogId,
				subFamilyId,
				applicationLocationId,
				lang
			})

			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request(payload) {
		return action(FETCH_REFERENCES.REQUEST, payload)
	}
	function success(payload) {
		return action(FETCH_REFERENCES.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_REFERENCES.FAILURE, null, err)
	}
}

export const GET_LAYER_DATA = createRequestTypes('GET_LAYER_DATA')
const getLayerData = ({ layer, catalogId, familyId, subFamilyId, lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await productsService.getLayerData({ layer, catalogId, familyId, subFamilyId, lang })
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(GET_LAYER_DATA.REQUEST)
	}
	function success(payload) {
		return action(GET_LAYER_DATA.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_LAYER_DATA.FAILURE, null, err)
	}
}

export const GET_DECISION_TREE = createRequestTypes('GET_DECISION_TREE')
const getDecisionTree = (decisionTreeCode) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await productsService.getDecisionTree(decisionTreeCode)
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(GET_DECISION_TREE.REQUEST)
	}
	function success(payload) {
		return action(GET_DECISION_TREE.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_DECISION_TREE.FAILURE, null, err)
	}
}

export const GET_PRODUCT_FROM_PRECONFIG = createRequestTypes('GET_PRODUCT_FROM_PRECONFIG')
const getProductFromPreconfig = (preconfigId) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await productsService.getProductFromPreconfig(preconfigId)
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(GET_PRODUCT_FROM_PRECONFIG.REQUEST)
	}
	function success(payload) {
		return action(GET_PRODUCT_FROM_PRECONFIG.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_PRODUCT_FROM_PRECONFIG.FAILURE, null, err)
	}
}

export const GENERATE_CREATION_CODE = createRequestTypes('GENERATE_CREATION_CODE')
const generateCreationCode = (prefixCode) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await productsService.generateCreationCode(prefixCode)
			return dispatch(success(res.data.creationCode))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(GENERATE_CREATION_CODE.REQUEST)
	}
	function success(payload) {
		return action(GENERATE_CREATION_CODE.SUCCESS, payload)
	}
	function failure(err) {
		return action(GENERATE_CREATION_CODE.FAILURE, null, err)
	}
}

export const BEGIN_CREATION_PRODUCT = 'BEGIN_CREATION_PRODUCT'
const beginCreatingProduct = (payload) => {
	return action(BEGIN_CREATION_PRODUCT, payload)
}
export const SELECT_ADD_MODEL = 'SELECT_ADD_MODEL'
const selectAddModel = (payload) => {
	return action(SELECT_ADD_MODEL, payload)
}

export default {
	fetchModels,
	fetchProductsByRef,
	fetchReferences,
	getLayerData,
	getDecisionTree,
	getProductFromPreconfig,
	generateCreationCode,
	beginCreatingProduct,
	selectAddModel
}
